import Widget from "./base.js";
import { getCookie } from "tpm-utils";
import getProfile from "tpm-lib/profile";

export class MeteredPrearticle extends Widget {
	//a lot of this logic is duplicated from metered-bumper
	//if we create more metered wigets, should refactor
	componentWillMount() {
		this.state.hidden = true;
		//if the paywall postmeta is set, never render this component
		if (window.has_paywall) return;

		let views = getCookie("tpm_article_views");
		if (views === null) views = 0;
		else views = parseInt(views);

		//we DO want to count the first and current article view, but the pvt might not have got to it yet
		//(race condition). If didtrack is falsy, lets increment the views to account for that
		if (!window.tpm_pvt || !window.tpm_pvt.didtrack) {
			views = views + 1;
		}

		//dont show this component after the 9th view
		if (views > 9) return;

		const profileData = this.getProfileData();
		const self = this;
		function initializeState(profile) {
			self.setState({
				views: views,
				membership_was: window.tpm_profile.membership_was,
				profile: profile,
				hidden: false,
			});
		}
		if (typeof profileData.then === "function") {
			// promise
			profileData.then((resp) => {
				initializeState(resp);
			});
		} else {
			//not a promise
			initializeState(profileData);
		}
	}

	getProfileData() {
		if (window.tpm_profile) return window.tpm_profile;
		return getProfile();
	}

	renderContent() {
		if (this.state.hidden) return;
		return (
			<div className={`MeteredPrearticle__Inner ${this.props.classnames}`}>
				<span class="MeteredPrearticle__Text">
					You have read <b>{this.state.views} of 9</b> free articles this month
				</span>
				<span class="MeteredPrearticle__Button --font-size-18">
					<a
						href={`https://${document.location.hostname}/memberships?utm_source=on_site&utm_medium=prearticle_button&utm_campaign=why_tpm`}
						className="ButtonPopout --white"
					>
						<span class="ButtonPopout__Outline"></span>
						<span class="ButtonPopout__Button">BECOME A MEMBER</span>
					</a>
				</span>
			</div>
		);
	}
}
